import {Consts} from "../../pages/consts";
import {useTranslation} from "react-i18next";
import {useState} from "react";

const DayTimeIntake = ({index, intake, onSetIntake}) => {
  const {t} = useTranslation();
  const [dosage, setDosage] = useState(isNaN(intake?.dosage) ? 0 : intake?.dosage);
  const [intakeTime, setIntakeTime] = useState(intake?.intakeTime);

  const handleChangeDosage = (e) => {
    setDosage(e.target.value);

    let dosage = 0;

    if(!isNaN(e.target.value)){
      dosage = +e.target.value;
    }

    onSetIntake({...intake, dosage}, index);
  }

  const handleChangeIntakeTime = (e) => {
    setIntakeTime(e.target.value);
    onSetIntake({...intake, intakeTime: e.target.value}, index);
  }

  const style = !isNaN(intake?.dosage) && intake?.dosage > 0 ? {color: "green"} : {};

  return (
    <div className="w3-border w3-border-orange w3-round-large w3-padding-small">
      <label className="bold-label" style={ style }>
        { t(Consts.DAY_TIME_NAMES[index]) }
      </label>
      <div className="w3-row w3-padding-small">
        <div className="w3-col s4">
          <label>{ t("dosage") }*</label>
        </div>
        <div className="w3-col s4">
          <input
            value={ dosage }
            name={ Consts.DAY_TIME_NAMES[index] }
            type={ Consts.NUMBER }
            min="1"
            onChange={ (e) => handleChangeDosage(e) }
            className="form-input"
          />
        </div>
        <div className="w3-col s4">
          <label className="label-margin-left">{ t(intake?.dosageUnit?.dosageUnit) }</label>
        </div>
      </div>
      <div className="w3-row w3-padding-small">
        <div className="w3-col s4">
          <label>{ t("time") }</label>
        </div>
        <div className="w3-col s8">
          <input
            value={ intakeTime }
            name={ Consts.DAY_TIME_NAMES[index] }
            type={ Consts.TIME }
            onChange={ (e) => handleChangeIntakeTime(e) }
            className="form-input"
          />
        </div>
      </div>
    </div>
  );
}

export default DayTimeIntake;